import * as React from "react";
import { IProperty } from "@origin-digital/shared-app-context";
import { isNative as isNativeCheck } from "@origin-digital/platform-helpers";
import { ICustomerCodeV2 } from "@origin-digital/shared-app-context/dist/typings/models";
import { KrakenAuthNav } from "@origin-digital/myaccount-navigation";
import { MasqueradeBanner } from "../Banner/MasqueradeBanner";
import { Header } from "../Header";
import { NavigationHeader } from "../NavigationHeader";

interface BaseAppContentProps {
  actionBar: Window["oetal"]["pageData"]["actionBar"];
  showHeader: Window["oetal"]["pageData"]["showHeader"];
  title: string;
}

interface MyAccountAppContentProps extends BaseAppContentProps {
  authenticated: boolean;
  isNative: boolean;
  customerCode?: ICustomerCodeV2;
  premiseId?: string;
  properties?: IProperty[];
  onSelectPremise: (premiseId: string) => void;
}

export const MyAccountAppContent: React.FC<MyAccountAppContentProps> = ({
  // eslint-disable-next-line no-shadow
  isNative,
  premiseId,
  properties,
  customerCode,
  showHeader,
  authenticated,
  actionBar = {},
  title,
  onSelectPremise,
}) => {
  return (
    <>
      <NavigationHeader
        showHeader={showHeader}
        authenticated={authenticated}
        customerCode={customerCode}
      />
      <Header
        title={actionBar.title || title}
        desktopVariant={actionBar.desktopVariant}
        component={actionBar.component}
        hideActionBar={actionBar.hidden}
        mobilePropertySelector={actionBar.mobilePropertySelector}
        mobileNavButton={actionBar.mobileNavButton}
        breadcrumbs={actionBar.breadcrumbs}
        onSelectPremise={onSelectPremise}
        premiseId={premiseId}
        premises={properties}
        isNative={isNative}
      />
    </>
  );
};

export const KrakenAppContent: React.FC<BaseAppContentProps> = ({
  actionBar = {},
  showHeader,
  title,
}) => {
  return (
    <>
      <MasqueradeBanner />
      {showHeader && (
        <KrakenAuthNav desktopVariant={actionBar.desktopVariant} />
      )}

      <Header
        component={actionBar.component}
        hideActionBar={actionBar.hidden}
        desktopVariant={actionBar.desktopVariant}
        mobilePropertySelector={actionBar.mobilePropertySelector}
        isNative={isNativeCheck()}
        mobileNavButton={actionBar.mobileNavButton}
        title={actionBar.title || title}
        breadcrumbs={actionBar.breadcrumbs}
      />
    </>
  );
};
